import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-445cecaa"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"common-agreement-container xa-line__full-top\" data-v-445cecaa><div class=\"pb32\" data-v-445cecaa><div class=\"title mt16 ftw\" data-v-445cecaa>投保须知</div><div class=\"content\" data-v-445cecaa> 1.本投保须知和适用条款是保险合同的组成部分，请您仔细阅读该条款，<span class=\"ftw\" data-v-445cecaa>特别注意有关责任免除、投保人、被保险人义务的规定。</span></div><div class=\"content\" data-v-445cecaa> 2.本保险适用条款由《无人机机身一切险及责任险条款》及其附加险条款组成，本保险仅承保投保方案中列明责任损失项目，其他未列明损失不属于本保险的保障内容。 </div><div class=\"content\" data-v-445cecaa> 3.本保险仅适用于在极飞科技或其他授权合作方等正规渠道在中国大陆销售的产品。 </div><div class=\"content\" data-v-445cecaa>4.同一保险标的，投保人同一时间限投保一份，多投保无效。</div><div class=\"content\" data-v-445cecaa> 5.投保人须如实填写投保人与被保险人的真实有效的组织机构代码证、社会信用代码、营业执照、税务登记证或身份证的证件号码，并认真核对确保无误。理赔时需要提供同填写信息一致的相关证件，如填写的证件号码与实际不符，保险公司不承担保险责任。 </div><div class=\"content\" data-v-445cecaa> 6.投保人须就页面上的所有信息进行如实填写，保险公司有权调查信息的真实情况。如果有故意隐瞒事实、不履行如实告知义务的，保险公司有权解除保险合同或不承担保险责任对已支付的赔偿。 </div><div class=\"content\" data-v-445cecaa> 7.根据《中华人民共和国民法典》相关规定，数据电文是合法的合同表现形式。投保人接受以中国平安财产保险股份有限公司提供的电子保单作为本投保书成立的合法有效凭证，具有完全证据效力。 </div></div></div>", 1)

import {} from 'vue'
import { useRouter } from 'vue-router'
import AppHeader from '@/components/Header.vue'
import CommonFooterNextButton from '@/components/CommonFooterNextButton.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'agreement',
  setup(__props) {

const $router = useRouter()

function back() {
  $router.go(-1)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, { title: "贷款协议" }),
    _hoisted_1,
    _createVNode(CommonFooterNextButton, {
      title: "返回",
      onClick: back
    })
  ], 64))
}
}

})